<template>
  <bcc-dialog :visible="show" top='10vh' width="500px" @close="handleCompanyDialog(false)">
    <!-- 状态(0待接收;1已接受;2已拒绝;3已撤销,4已解绑) -->
    <template v-if='[0,1,4].includes(data.state)'>
      <h3>{{ isManager ? '管理员授权' : '开发者授权' }}</h3>
      <p class="des">{{ isManager ? '请通知被邀请者24小时内登录哔哩哔哩开放平台，进入【管理中心-授权管理】接受邀请，若超时未进行操作，则默认拒绝邀请' : '请通知被邀请者24小时内登录哔哩哔哩开放平台，进入【管理中心-授权管理】接受邀请，若超时未进行操作，则默认拒绝邀请'}}</p>
      <div class="auth-group">
        <span>授权权限:</span>  
        <!-- <bcc-checkbox-group v-if='isManager' class="check-box" disabled v-model="limits">
          <bcc-checkbox label="企业信息编辑权限"></bcc-checkbox>
          <bcc-checkbox label="申请应用权限"></bcc-checkbox>
          <bcc-checkbox label="应用管理权限"></bcc-checkbox>
          <bcc-checkbox label="授权开发者权限"></bcc-checkbox>
          <bcc-checkbox label="邀请管理员权限"></bcc-checkbox>
        </bcc-checkbox-group> -->
        <div class="check-box-new" v-if='isManager'>
          <div v-for='(item, idx) in limits' :key='idx' class="item">
            {{item}}
          </div>
        </div>
        <div class="check-box-new" v-if='isDeveloper'>
          <div v-for='(item, idx) in data.app_names' :key='idx' class="item">
            {{item}}
          </div>
        </div>
        <!-- <bcc-checkbox-group v-if='isDeveloper' class="check-box" disabled v-model="data.app_names">
          <div class="app-list-box">
            <bcc-checkbox v-for="(item, idx) in data.app_names" :key="idx" :label="item">{{item}}</bcc-checkbox>
          </div>
        </bcc-checkbox-group> -->
      </div>
      <div slot="footer">
        <bcc-button v-if='canCallBack' :disabled='data.state === 4' @click="handleBack" size="middle" type="primary">撤销授权</bcc-button>
        <bcc-button v-else @click="show = false" size="middle" type="primary">关闭</bcc-button>
      </div>
    </template>
    <template v-if='[2,3].includes(data.state)'>
      <h3>{{ getRejectTxt }}授权记录</h3>
      <p class="des" />
      <div>
        <span>{{getRejectTxt}}授权者:</span>  
        <span style="padding-left:10px;margin-top:10px">{{ data.mname_to }}</span>
      </div>
      <div class="auth-group" style="margin-left:0">
        <span>{{getRejectTxt}}授权权限:</span>  
        <bcc-checkbox-group v-if='isManager' class="check-box" disabled v-model="limits">
          <bcc-checkbox label="企业信息编辑权限"></bcc-checkbox>
          <bcc-checkbox label="申请应用权限"></bcc-checkbox>
          <bcc-checkbox label="应用管理权限"></bcc-checkbox>
          <bcc-checkbox label="授权开发者权限"></bcc-checkbox>
          <bcc-checkbox label="邀请管理员权限"></bcc-checkbox>
        </bcc-checkbox-group>
        <bcc-checkbox-group v-if='isDeveloper' class="check-box" disabled v-model="data.app_names">
          <div class="app-list-box">
            <bcc-checkbox falseValue="" v-for="(item, idx) in data.app_names" :key="idx" :label="item">{{item}}</bcc-checkbox>
          </div>
        </bcc-checkbox-group>
      </div>
      <div slot="footer">
        <bcc-button @click="show = false" size="middle" type="primary">关闭</bcc-button>
      </div>
    </template>
  </bcc-dialog>
</template>
<script>
export default {
  data () {
    return {
      show: false,
      data: {},
      limits: [
        '企业信息编辑权限',
        '申请应用权限',
        '应用管理权限',
        '授权开发者权限',
        '邀请管理员权限'
      ]
    }
  },
  computed: {
    isManager () {
      return this.data.level === 20
    },
    isDeveloper () {
      return this.data.level === 30
    },
    getRejectTxt () {
      return this.data.state === 2 ? '拒绝' : '撤销'
    },
    canCallBack () {
      if (this.$store.state.arcUserInfo.level === 1 || (this.$store.state.arcUserInfo.level === 20 && this.data.level === 30)) { // 超管 || 管理员撤销开发者
        return true
      }
      return false
    }
  },
  methods: {
    handleCompanyDialog () {
      this.show = false
    },
    async handleBack () {
      this.$confirm({
        mainText: this.isManager ? '撤销管理员授权' : '撤销开发者授权',
        subText: this.isManager ? '是否确定撤销授权？撤销授权后，该账号将失去所有管理员权限' : '是否确定撤销授权？撤销授权后，该开发者将失去本次被授权应用的权限',
        showCancel: true,
        onOk: async() => {
          this.$api.auth.handleBack({
            id: this.data.id
          }).then(() => {
            this.$message({
              content: '撤销成功',
              type: 'success',
              offset: 60,
              duration: 1500
            })
            this.show = false
            this.$emit('refreshData')
          }).catch((e) => {
            this.$message({
              content: e.message,
              type: 'exception',
              offset: 60,
              duration: 1500
            })
          })
        },
        onCancel: () => {
          console.log('cancel')
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.des {
  margin-top: 30px;
}
.auth-group {
  // margin-left: 40px;
  display: flex;
  margin-top: 30px;
}
.check-box-new {
  margin-left: 88px;
  .item {
    color: #999999;
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 12px;
    position: relative;
    &::before {
      position: absolute;
      left: -10px;
      top: 6px;
      background: rgba(0, 0, 0, 0.25);
      content: '';
      width: 4px;
      height: 4px;
      border-radius: 50%;
    }
  }
}
.check-box {
    flex-direction: column;
    margin-left: 20px;
    margin-top: -9px;
    .bcc-checkbox {
      margin-left: 0;
      margin-top: 15px;
      &:first-child {
        margin-top: 10px;
      }
      ::v-deep .bcc-checkbox-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 300px;
      }
    }
  }
</style>
